import { Button, Checkbox, DatePicker, Form, Image, Input, Select, Upload } from 'antd'
import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import { AUTH, GET } from '../../../utils/apis'
import { errorMessage, successMessage } from '../../../utils/helpers'
import DoctorChangePassword from './DoctorChangePassword'

const DoctorProfile = (props) => {
    const { user, authActions, language, selectedLanguage, userActions } = props
    const [loading, setLoading] = useState(false)
    const formRef = useRef(null)
    const onFinish = (values) => {
        values._id = user._id
        setLoading(true)
        axios.post(AUTH.UPDATE_DOCTOR_SETTINGS, values)
            .then((res) => {
                const { data } = res
                console.log('============data', data)
                setLoading(false)
                if (data.success) {
                    successMessage('Profil eUpdated Successfully')
                    authActions.loginUser(data.user)
                    return window.location.reload()
                }
                errorMessage(/* assignMessage(message, language?.language) */data.message)
            })
            .catch((e) => {
                console.log('error', e)
                setLoading(false)
                errorMessage(/* assignMessage(message, language?.language) */e.message)
            })
    }
    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_profile}</h1>
                    </div>
                </div>
                <div className="appointment-form-container">
                    <Form
                        // name='form'
                        onFinish={onFinish}
                        layout={'vertical'}
                        requiredMark={false}
                        ref={formRef}
                    >
                        <div className='form-two-input-flex'>
                            <div className='form-two-input-flex-inner-input'>
                                <Form.Item
                                    name='fullName'
                                    label={selectedLanguage?.txt_full_name}
                                    initialValue={user?.drName}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: selectedLanguage?.txt_input_your_full_name
                                        }
                                    ]}
                                >
                                    <Input
                                        className='form-input-new-style'
                                        placeholder={selectedLanguage?.txt_input_your_full_name}
                                    />
                                </Form.Item>
                            </div>
                            <div className='form-two-input-flex-inner-input'>
                                <Form.Item
                                    name='email'
                                    label={selectedLanguage?.input_email_placeholder}
                                    initialValue={user?.email}
                                >
                                    <Input
                                        className='form-input-new-style'
                                        placeholder={selectedLanguage?.txt_please_input_your_email}
                                        disabled
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <Form.Item>
                            <Button
                                type='primary'
                                style={{ marginTop: '10px', height: '45px' }}
                                className='new-button-for-profile'
                                htmlType='submit'
                                loading={loading}
                            >
                                {selectedLanguage?.txt_update_profile}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
                <hr />
                <DoctorChangePassword {...props} />
            </div>
        </div>
    )
}

export default DoctorProfile